import { render } from "./list-soal-peserta.vue?vue&type=template&id=e7776a94&scoped=true"
import script from "./list-soal-peserta.vue?vue&type=script&lang=js"
export * from "./list-soal-peserta.vue?vue&type=script&lang=js"

import "./list-soal-peserta.vue?vue&type=style&index=0&id=e7776a94&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7776a94"]])

export default __exports__